import { createCustomEnum } from "./customEnum";

const CreditReviewColumns = createCustomEnum({
	MerchantName: {
		value: 0,
		name: "merchantName",
		displayName: "Merchant Name (DBA)",
	},
	SalesMonthlyVolume: {
		value: 1,
		name: "salesMonthlyVolume",
		displayName: "Sales Monthly Volume, $",
	},
	CreditExposure: {
		value: 2,
		name: "creditExposure",
		displayName: "Credit Exposure, $",
	},
});
export default CreditReviewColumns;
